import React from "react";

import clsx from "clsx";

const NUM_OF_PLACEHOLDER_ROWS = 4;

const PlaceholderRow = ({ isLastRow }: { isLastRow: boolean }) => (
  <div className="border border-t-0 border-x-0 border-b-gray-2 last:border-b-0 flex h-9">
    <div
      className={clsx(
        "text-xs font-semibold p-2 w-24 bg-white flex items-center",
        { "rounded-bl-md": isLastRow },
      )}
    >
      <div className="w-4 h-4 bg-cosmic-4 border border-gray-2 rounded-full" />
      <div className="w-12 h-3 ml-2 bg-gray-2" />
    </div>
    <div className="border border-r-0 border-l-gray-2" />
  </div>
);

export const NoMetricTable = () => (
  <div className="h-full w-full grid grid-rows-5 bg-cosmic-5 rounded-md">
    <div className="border border-t-0 border-x-0 border-b-gray-2 flex">
      <div className="text-xs font-semibold p-2 w-24 bg-white flex items-center rounded-tl-md">
        Platform
      </div>
      <div className="border border-r-0 border-l-gray-2 my-2" />
    </div>
    {Array.from({ length: NUM_OF_PLACEHOLDER_ROWS }).map((_, i) => (
      <PlaceholderRow key={i} isLastRow={i + 1 === NUM_OF_PLACEHOLDER_ROWS} />
    ))}
  </div>
);
